// TextUserAvatar.jsx
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useInView } from 'react-intersection-observer';

import { textColor } from '../style/variables.js';

import AvatarPlaceholder from '../../img/placeholder-avatar-cube-60.svg';

const OBSERVER_OPTIONS = {
  triggerOnce: true,
};

const TextUserAvatar = ({
  meId = null,
  userId = null,
  username = '',
  avatarColor = '#191919',
  avatarSize = 24,
  fontSize = null,
  fetchUser = () => null,
}) => {
  const { ref, inView: isIntersected } = useInView(OBSERVER_OPTIONS);
  useEffect(() => {
    if (isIntersected && userId && !username) {
      fetchUser({ userId });
    }
  }, [isIntersected, username, userId, meId, fetchUser]);

  const firstCharacter =
    username?.replace(/^@/, '').slice(0, 1).toUpperCase() || '';
  if (!userId) {
    return (
      <StyledTextUserAvatar
        avatarColor={avatarColor}
        avatarSize={avatarSize}
        fontSize={fontSize ? fontSize : avatarSize * 0.5}
      >
        <img src={AvatarPlaceholder} alt="avatar placeholder" />
      </StyledTextUserAvatar>
    );
  }
  return (
    <StyledTextUserAvatar
      ref={ref}
      avatarColor={avatarColor}
      avatarSize={avatarSize}
      fontSize={fontSize ? fontSize : avatarSize * 0.5}
    >
      {firstCharacter}
    </StyledTextUserAvatar>
  );
};

TextUserAvatar.propTypes = {
  username: PropTypes.string,
  userId: PropTypes.string,
  meId: PropTypes.string,
  avatarColor: PropTypes.string,
  avatarSize: PropTypes.number,
  fontSize: PropTypes.number,
  fetchUser: PropTypes.func,
};

const StyledTextUserAvatar = styled.div.attrs(
  ({ avatarSize, fontSize, avatarColor }) => ({
    style: {
      width: `${avatarSize}px`,
      height: `${avatarSize}px`,
      fontSize: `${fontSize}px`,
      backgroundColor: avatarColor,
    },
  })
)`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${textColor.white};
  > img {
    border-radius: 50%;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export { TextUserAvatar };
export default TextUserAvatar;
